<!-- 加速检 -->
<template>
  <!-- 验收记录单 -->
  <h-inspection-page-new :title="h_i18n('ae9b9e9cea1400387a36eb46740cf07c')" @inspection-update="inspectionUpdate" style="background: #F2F4F7;" :isOwnBack="true">
    <!-- 验收记录单 -->
    <inspection-header-new :title="h_i18n('ae9b9e9cea1400387a36eb46740cf07c')" title-height="80px" :showNewLogo="true">
      <template #title>
        <!-- 表号 -->
        <h-p align="left" :title="h_i18n('4850ea222f13bd23bec1cdace19cb633')">002-C0301-0/C-F02</h-p>
        <!-- 编号 -->
        <h-p align="left" :title="h_i18n('c515f3385e7740c52e22eefc10b62f2b')">{{ topData.patternPlanId }}</h-p>
      </template>
      <template #body>
        <div class="detail-content" style="margin-top: 16px;">
          <div class="detail-item">
            <!-- 专用号： -->
            <div class="item-label">{{ h_i18n('7c7fefb36371a5a9ab5338c98790c67c') }}</div>
            <div class="item-content">{{ topData.mtlNo }}</div>
          </div>
          <div class="detail-item">
            <!-- 物料名称： -->
            <div class="item-label">{{ h_i18n('7a0ae7305076f170b4a920ef5f3f04f9') }}</div>
            <div class="item-content">{{ topData.mtlName }}</div>
          </div>
          <div class="detail-item">
            <!-- 工厂小微： -->
            <div class="item-label">{{ h_i18n('2153e04c74140dd4926dd724aad0d2a7') }}</div>
            <div class="item-content">{{ topData.sybName }}</div>
          </div>
          <div class="detail-item">
            <!-- 供应商代码： -->
            <div class="item-label">{{ h_i18n('15be0cbf984ead7733f52bbd01db11a2') }}</div>
            <div class="item-content">{{ topData.supplyCode }}</div>
          </div>
        </div>
        <div class="detail-content" style="margin-top: 12px;">
          <div class="detail-item">
            <!-- 供应商名称： -->
            <div class="item-label">{{ h_i18n('eb0e130294c8c3b3fa2cfecc849fec49') }}</div>
            <div class="item-content">{{ topData.supplyName }}</div>
          </div>
          <div class="detail-item">
            <!-- 供方检验资格： -->
            <div class="item-label">{{ h_i18n('be5067b9c3d89ddada898b2dfb7a40c4') }}</div>
            <div class="item-content">{{ supplyCheckM(topData.supplyCheckLevel) }}</div>
          </div>
          <div class="detail-item">
            <!-- 物料组： -->
            <div class="item-label">{{ h_i18n('222e3ac8bc88ec36a331f8639be6d029') }}</div>
            <div class="item-content">{{ topData.mtlGroup }}</div>
          </div>
          <div class="detail-item">
            <!-- 物料大类： -->
            <div class="item-label">{{ h_i18n('70ab9180fbc7101df91637a8c7372a7c') }}</div>
            <div class="item-content">{{ topData.materielCategoryName }}</div>
          </div>
        </div>
        <div class="detail-content" style="margin-top: 12px;">
          <div class="detail-item">
            <!-- 产品编码： -->
            <div class="item-label">{{ h_i18n('7ca3d20b6df0d10179e222f202da6bc8') }}</div>
            <div class="item-content">{{ topData.matchingModel }}</div>
          </div>
          <div class="detail-item">
            <!-- 检验方式： -->
            <div class="item-label">{{ h_i18n('62d773f2fea6b5cc3313bfa1d0af5df4') }}</div>
            <div class="item-content">{{ checkTypeM(topData.checkTypeId) }}</div>
          </div>
          <div class="detail-item">
            <!-- 计划生成时间： -->
            <div class="item-label">{{ h_i18n('71659f5eaba3d094009a9be961059e43') }}</div>
            <div class="item-content">{{ time(topData.sendDay, 6) }}</div>
          </div>
          <div class="detail-item">
            <!-- 预计完成时间： -->
            <div class="item-label">{{ h_i18n('f6e4c1f0d4cb1af4bbd59242191c648e') }}</div>
            <div class="item-content">{{ time(topData.wjPlanCheckDate, 3) }}</div>
          </div>
        </div>
      </template>
    </inspection-header-new>
    <inspection-body-new>
      <vxe-table border ref="xTable" :row-config="{isHover: true,height: 35}"
                 :scroll-y="{mode: 'whell',gt: 50}" height="700" round
                 style="width: 100%;margin-top: 5px;border-radius:8px;" :column-config="{resizable: true}" :loading="tableLoading"
                 :data="dataTableList" :span-method="arraySpanMethod"
                 @checkbox-change="handleSelectionChange" :row-class-name="rowClassName"
                 @checkbox-all="handleSelectionChange"
                 :edit-config="{trigger: 'click', mode: 'cell'}">
        <!--        <vxe-column type="checkbox" width="30" fixed="left"></vxe-column>-->
        <!-- 序号 -->
        <vxe-column :title="h_i18n('faaadc447b1c2b1adc920d9c9aedcc25')" width="50" fixed="left">
          <template #default="{row}">
            <template v-if="row.frontKey==='QB'||row.frontKey==='QB_NEW'">
              <!-- 企标：；企标名称： -->
              <div style="text-align: left;height: 36px;display: flex;align-items: center">{{ h_i18n('c002044068ba901616b0e772ea3c5f5c') }}<span style="color: #165dff;">{{ row.templateCode }}</span>{{ h_i18n('832b6565865ffcaa933399710f6f15d3') }}<span style="color: #165dff;">{{ row.templateName }}</span>
              </div>
            </template>
            <template v-else>
              {{ row.frontIndex }}
            </template>
          </template>
        </vxe-column>
        <!-- 检验项目 -->
        <vxe-column :title="h_i18n('222c0f1a6341c9df01ca58fc982db93b')" min-width="130" show-overflow fixed="left">
          <template #default="{row}">
            {{ row.itemName }}
          </template>
        </vxe-column>
        <!-- 检验类别 -->
        <vxe-column :title="h_i18n('f4aadbe7c1febb0b5cd8c1a9164319e3')" width="100" fixed="left">
          <template #default="{row}">
            {{ row.itemCodeName }}
          </template>
        </vxe-column>
        <!-- 技术（标准）要求 -->
        <vxe-column :title="h_i18n('afb44627fabcf435b4633f1f6bd12eb3')" min-width="200" show-overflow fixed="left">
          <template #default="{row}">
            {{ row.remark }}
          </template>
        </vxe-column>
        <!-- 数据类别 -->
        <vxe-column :title="h_i18n('bd9d32f9b63c551e252decdf8b3c854b')" field="" width="80">
          <template #default="{row}">
            {{ row.dataType }}
          </template>
        </vxe-column>
        <!-- 样本大小 -->
        <vxe-column :title="h_i18n('9e23b61ce24cfada6fea1cdc2277976c')" width="100">
          <template #default="{row}">
            {{ row.patternNo }}
          </template>
        </vxe-column>
        <!-- 判定数 -->
        <vxe-colgroup :title="h_i18n('9ad6f829b961e347a0c8233ea1e57e42')" width="140">
          <vxe-column title="Ac" width="50">
            <template #default="{row}">
              {{ row.acDeterminant }}
            </template>
          </vxe-column>
          <vxe-column title="Re" width="50">
            <template #default="{row}">
              {{ row.reDeterminant }}
            </template>
          </vxe-column>
        </vxe-colgroup>
        <!-- 实测值 -->
        <vxe-colgroup :title="h_i18n('c5fb490f9763ca6e6320049b20e23a92')" width="140">
          <vxe-column v-for="i in 13" :label="i" min-width="35" :title="i" :key="i">
            <template #default="{row}">
              <template v-if="row.reportMark">
                <div style="display: flex;justify-content: flex-start;align-items: center">
                  <!-- 借用 -->
                  <div class="h-global-font--blue">{{ row.reportId }}</div>{{ h_i18n('5d971fd19163b05640a0d04c894a3ea7') }}</div>
              </template>
              <template v-else-if="row.testReportType==='Y'">
                <div style="display: flex;justify-content: flex-start;align-items: center">
                  <!-- 正常；检测-已发布 -->
                  <div v-if="row.testAdminAuditSign===h_i18n('fd6e80f1e0199d6ecc3ee81ae04aa9ef')||row.testAdminAuditSign===h_i18n('ff14583e03f24e10c35ad59d46d9015a')">
                    <!-- 状态:；试验员: -->
                    {{ row.factTestValue }}{{ h_i18n('13b5c7509d81fefed45711381cd7ee67') }}{{ row.testAdminAuditSign }}{{ h_i18n('3252e1722660aff48898ba6d45043f0f') }}{{ row.assignToTrier }}
                  </div>
                  <!-- 审核人员(订单经理)要求修改 -->
                  <div v-else-if="row.testAdminAuditSign===h_i18n('d2ada8222027ff847cfbbdcf4ee24efa')">
                    <!-- 状态:；试验员: -->
                    {{ row.factTestValue }}{{ h_i18n('13b5c7509d81fefed45711381cd7ee67') }}{{ row.testAdminAuditSign }}{{ h_i18n('3252e1722660aff48898ba6d45043f0f') }}{{ row.assignToTrier }}
                  </div>
                  <!-- 检测-实验员打回 -->
                  <div v-else-if="row.testAdminAuditSign===h_i18n('442d11878a77e98acad37cbbe68fb362')">
                    <!-- 状态:；试验员: -->
                    {{ row.factTestValue }}{{ h_i18n('13b5c7509d81fefed45711381cd7ee67') }}{{ row.testAdminAuditSign }}{{ h_i18n('3252e1722660aff48898ba6d45043f0f') }}{{ row.assignToTrier }}
                  </div>
                  <div v-else>
                    <!-- 状态:；试验员: -->
                    {{ row.factTestValue }}{{ h_i18n('13b5c7509d81fefed45711381cd7ee67') }}{{ row.testAdminAuditSign }}{{ h_i18n('3252e1722660aff48898ba6d45043f0f') }}{{ row.assignToTrier }}
                  </div>
                </div>
              </template>
              <template v-else>
                <div style="display: flex;align-items: center;justify-content: flex-start">
                  {{ row.factTestValue }}
                </div>
              </template>
            </template>
          </vxe-column>
        </vxe-colgroup>
        <!-- 重要性 -->
        <vxe-column :title="h_i18n('4626e7457839719f5fa1b08526e5e3fd')" width="80" title-help>
          <template #default="{row}">
            {{ row.importancePropertyName }}
          </template>
        </vxe-column>
        <!-- 判别水平 -->
        <vxe-column :title="h_i18n('be1fa802bb9d3e890344d1033fbf0933')" width="80">
          <template #default="{row}">
            {{ row.deterLevelName }}
          </template>
        </vxe-column>
        <vxe-column title="RQL" width="60">
          <template #default="{row}">
            {{ row.rqlProperty }}
          </template>
        </vxe-column>
        <!-- 范围 -->
        <vxe-colgroup :title="h_i18n('df011658c33f610e9b9d3302909a7f2b')" title-help>
          <vxe-column title="Min" width="70">
            <template #default="{row}">
              {{ row.testAreaMin }}
            </template>
          </vxe-column>
          <vxe-column title="Max" width="70">
            <template #default="{row}">
              {{ row.testAreaMax }}
            </template>
          </vxe-column>
        </vxe-colgroup>
        <!-- 单位 -->
        <vxe-column :title="h_i18n('f2996845b6bf0a07fe26f74f35e42ebe')" width="60">
          <template #default="{row}">
            {{ row.unit }}
          </template>
        </vxe-column>
        <!-- 结果判定 -->
        <vxe-column :title="h_i18n('0e8a40b9150d5f2aebbd153153f92bc1')" width="80">
          <template #default="{row}">
            <!-- 合格 -->
            <div v-if="row.singleDeterminant==='P'" class="successColor">{{ h_i18n('86f720320b77bb62311f0a4811db04fe') }}</div>
            <!-- 不合格 -->
            <div v-else-if="row.singleDeterminant==='F'" class="dangerColor">{{ h_i18n('6e5a122013138ad189517d5d0a1c0891') }}</div>
            <div v-else></div>
          </template>
        </vxe-column>
        <!--        <vxe-column title="检验方法" width="100" v-if="deleteSign">-->
        <!--          <template #default="{row}">-->
        <!--            <template v-if="row.frontKey==='ITEM_NEW'">-->
        <!--              <el-input v-model="row.checkMethod"></el-input>-->
        <!--            </template>-->
        <!--            <template v-else></template>-->
        <!--          </template>-->
        <!--        </vxe-column>-->
        <!--        <vxe-column title="检验工具" width="130" v-if="deleteSign">-->
        <!--          <template #default="{row}">-->
        <!--            <template v-if="row.frontKey==='ITEM_NEW'">-->
        <!--              <el-select v-model="row.equipmentTypeId" placeholder="请选择" @change="equipmentTypeChange(row)">-->
        <!--                <el-option v-for="item in deviceTypeList" :key="item.equipmentTypeId" :label="item.equipmentTypeName" :value="item.equipmentTypeId"></el-option>-->
        <!--              </el-select>-->
        <!--            </template>-->
        <!--            <template v-else></template>-->
        <!--          </template>-->
        <!--        </vxe-column>-->
        <!--        <vxe-column title="工具型号" width="130" v-if="deleteSign">-->
        <!--          <template #default="{row}">-->
        <!--            <template v-if="row.frontKey==='ITEM_NEW'">-->
        <!--              <el-select v-model="row.equipmentModel" placeholder="请选择" :disabled="isDisabled(row)">-->
        <!--                <el-option v-for="item in toolTypeList" :key="item.equipmentType" :label="item.equipmentName" :value="item.equipmentType"></el-option>-->
        <!--              </el-select>-->
        <!--            </template>-->
        <!--            <template v-else></template>-->
        <!--          </template>-->
        <!--        </vxe-column>-->
        <!--        <vxe-column title="易出现缺陷" width="100" v-if="deleteSign">-->
        <!--          <template #default="{row}">-->
        <!--            <template v-if="row.frontKey==='ITEM_NEW'">-->
        <!--              <el-input v-model="row.easyFault"></el-input>-->
        <!--            </template>-->
        <!--            <template v-else></template>-->
        <!--          </template>-->
        <!--        </vxe-column>-->
      </vxe-table>
    </inspection-body-new>
    <!-- <inspection-footer>
      <template #body>
        <h-tr>
          检测结论
        </h-tr>
        <tr>
          <h-td title="检测结果">
            <div style="display: flex;align-items: center;">
              <span v-if="topData.testConclusion === 'P'">合格</span>
              <span v-if="topData.testConclusion === 'F'" style="font-weight: 900;color: red">不合格</span>
              <span v-else></span>
            </div>
          </h-td>
          <h-td title="检测人">{{ $route.query.dataFrom == 'sqm' ? "-" : topData.iqcManagerName }}</h-td>
          <h-td title="检测时间">{{ time(topData.checkCompleteDate, 6) }}</h-td>
        </tr>
        <tr>
          <h-td title="尺寸见证资料" colspan="5">
            <div style="display: flex;flex-direction: column">
              <div style="display: flex;flex:1;overflow-x: auto" v-if="fileUploadToOss.picList.length>0">
                <div style="display: flex;flex-direction: column;cursor: pointer;padding: 5px 0">
                  <div style="color: #2681ff;" v-for="(v,i) in fileUploadToOss.picList"
                       @click="download(v.filePath)">{{ v.fileName }}
                  </div>
                </div>
              </div>
            </div>
          </h-td>
        </tr>
        <tr>
          <h-td title="第三方报告及快速报验申请等资料" colspan="5">
            <div style="display: flex;flex-direction: column">
              <div style="display: flex;flex:1;overflow-x: auto" v-if="fileUploadToOss.filList.length>0">
                <div style="display: flex;flex-direction: column;cursor: pointer;padding: 5px 0">
                  <div style="color: #2681ff;" v-for="(v,i) in fileUploadToOss.filList"
                       @click="downloadPDF(v.filePath)">{{ v.fileName }}
                  </div>
                </div>
              </div>
            </div>
          </h-td>
        </tr>
      </template>
      <template #footer>
        <h-button-group align="center">
          <h-button size="big" @click="$router.back()">返回</h-button>
        </h-button-group>
      </template>

    </inspection-footer> -->
    <!-- 检测结论 -->
    <form-area-new :title="[h_i18n('d2ee7282cedddfa2811959c5556e921f')]" :isShowFooter="false">
      <template #default="{value}">
        <!-- 检测结论 -->
        <form-body-new v-if="value===h_i18n('d2ee7282cedddfa2811959c5556e921f')">
          <tr class="myTr" >
            <!-- 检测结果 -->
            <report-td-new colspan="3:5" :title="h_i18n('77b9b1d1720981ebe160fd67cdd61db9')">
              <div style="display: flex;align-items: center;">
                <!-- 合格 -->
                <span v-if="topData.testConclusion === 'P'">{{ h_i18n('86f720320b77bb62311f0a4811db04fe') }}</span>
                <!-- 不合格 -->
                <span v-if="topData.testConclusion === 'F'" style="font-weight: 900;color: red">{{ h_i18n('6e5a122013138ad189517d5d0a1c0891') }}</span>
                <span v-else></span>
              </div>
            </report-td-new>
            <!-- <report-td-new colspan="3:5" title="检测人">{{ $route.query.dataFrom == 'sqm' ? "-" : topData.iqcManagerName }}</report-td-new> -->
            <!-- 检测时间 -->
            <report-td-new colspan="3:13" :title="h_i18n('44c4227175922c94497714edab9db531')">{{ time(topData.checkCompleteDate, 6) }}</report-td-new>
          </tr>
          <tr>
            <!-- 尺寸见证资料 -->
            <report-td-new colspan="3:21" :title="h_i18n('191f21b6c15eb2862e9d0acd1691eba5')">
              <div style="display: flex;flex-direction: column">
                <div style="display: flex;flex:1;overflow-x: auto" v-if="fileUploadToOss.picList.length>0">
                  <div style="display: flex;flex-direction: column;cursor: pointer;padding: 5px 0">
                    <div style="color: #2681ff;" v-for="(v,i) in fileUploadToOss.picList" :key="i"
                        @click="download(v.filePath,v.fileName)">{{ v.fileName }}
                    </div>
                  </div>
                </div>
              </div>
            </report-td-new>
          </tr>
          <tr>
            <!-- 第三方报告及快速报验申请等资料 -->
            <report-td-new colspan="3:21" :title="h_i18n('9e2ffe1243748c59ea3c0b53687f99dc')">
              <div style="display: flex;flex-direction: column">
                <div style="display: flex;flex:1;overflow-x: auto" v-if="fileUploadToOss.filList.length>0">
                  <div style="display: flex;flex-direction: column;cursor: pointer;padding: 5px 0">
                    <div style="color: #2681ff;" v-for="(v,i) in fileUploadToOss.filList" :key="i"
                        @click="downloadPDF(v.filePath,v.fileName)">{{ v.fileName }}
                    </div>
                  </div>
                </div>
              </div>
            </report-td-new>
          </tr>
          <tr>
            <!-- 外检负责人校核结论 -->
            <report-td :title="h_i18n('50870b5c342d62e61dad40cafd007ace')" bg-color="#F1F2F8" colspan="3:5">
              <el-radio-group v-model="topData.iqcLeaderMaterialConclusion" disabled>
                <!-- 合格 -->
                <el-radio label="P">{{ h_i18n('86f720320b77bb62311f0a4811db04fe') }}</el-radio>
                <!-- 不合格 -->
                <el-radio label="F">{{ h_i18n('6e5a122013138ad189517d5d0a1c0891') }}</el-radio>
                <!-- 打回 -->
                <el-radio label="R">{{ h_i18n('9a7b15dccc5cda2e3db1110678576104') }}</el-radio>
              </el-radio-group>
            </report-td>
            <!-- 外检负责人 -->
            <report-td :title="h_i18n('fc4ed0419f8799cba7678812a2e3eae1')" bg-color="#F1F2F8" colspan="3:5">-</report-td>
            <!-- 负责人校核时间 -->
            <report-td :title="h_i18n('67cff284a29663057baa6c1d3043ad53')" bg-color="#F1F2F8" colspan="3:5">{{ time(topData.iqcLeaderMaterialAuditDate, 6) }}</report-td>
          </tr>
          <tr class="myTr1">
            <!-- 外检负责人校核意见 -->
            <report-td :title="h_i18n('ac42ce6b7e74022c9a7a77037b138f30')" colspan="3:21">
              <el-input type="textarea" v-model="topData.iqcLeaderMaterialMark" :rows="1" maxlength="200" disabled></el-input>
            </report-td>
          </tr>
        </form-body-new>
      </template>
      <template #footer>
        <h-button-group align="center">
          <!-- 返回 -->
          <h-button size="big" @click="$router.back()">{{ h_i18n('5f411223ca5a01a5adf20fe735a433d0') }}</h-button>
        </h-button-group>
      </template>
    </form-area-new>
  </h-inspection-page-new>
</template>






<script>
//Automatic script writing.
import h_i18n from '@/utils/Internationalization';

import axios from "axios";

export default {
  name: "InspectionPlanView",
  data() {
    return {
      femaleParent: {}, // 对标母本
      benchmarkingTheMotherPlan: {
        benchmarkingTheMotherType: true,//对标母本印记
        benchmarkingTheMotherFlag: false,//对标母本弹窗
        mtlSelectList: [],//专用号搜索
      },
      searchData: {
        mtlNo: '',
      },
      plan: {
        showMtlPlan: false,
      },
      loading: {
        mtlLoading: false,
      },
      baseData: {},
      dataTable: [],
      deviceTypeList: [],
      picBig: false,
      tableLoading: false,//loading
      handleSelection: [],//多选
      testConclusion: "P",//测试结果
      fileUploadToOss: {
        fileChoose: false,//文件上传面版
        openPlan: "",//当前面板属于那个
        picList: [],
        filList: [],
        fil2List: [],
        nowList: []
      },
      fileList: [],//文件上传列表
      testName: "",//测试人
      testTime: "",//测试日期
      name: "",
      topData: {}, // 验收记录单明细
      checkTableList: [], // 元数据
      treeCopyList: [],//数据企标
      dataTableList: [],//数据list
      defaultTag: false,//原生标记，出了不合格true否则为false
      taskId: null,
      projectCategory: [],//项目类别
      projectCategoryCustom: [],//项目类别自定义的
      importance: [],//重要性
      inspectionLevel: [],//判别水平
      specialNumberBasisList: [],//专用号依据里面的相关信息，包含要对应的企标
      borrowingReport: {
        text: "",//借用报告
        show: false,//借用报告列表弹出框
        borrowingReportList: [],//借用报告list
        borrowingReportSign: false,//借用报告可输入标记
        // 请至少选择一项检验类别标记为'性能'的数据
        borrowingReportPlaceholder: h_i18n('bdb47a855ebe341be9353e67f7ae8832'),//借用报告的提示内容
        disabled: true,
        loading: false,
        tableLoading: false,
        plane: false
      },
      putOnExperimentPlan: {
        disabled: true,
      },
      deleteSign: false,//出现操作列的标记
      config: false,
      reduceExpenditure: {
        borrowingReport: null,//节流---借用报告
      },
      http: {
        borrowingReportHttp: null,//http请求，借用报告
      },
      unqualifiedQuantityOldList: [],//不合格数量原始数据
      unqualifiedQuantity: {
        show: false,//弹出框面板
        button: false,//弹出按钮
        unqualifiedQuantityList: [],//不合格数量
      },
      toolTypeList: [],//工具型号
    }
  },
  methods: {
    h_i18n,
    //焦点失去
    searchFactTestValueBlur(e, row) {
      if (row.factTestValue === "" || !row.factTestValue) {
        return
      }
      if (row.factTestValue.toUpperCase().substring(0, 2) === "HR") {
        // 报告查询中...
        this.startLoading(h_i18n('529ef70f117b975815aa43b4662f939a'))
        this.$http({
          method: "get",
          url: "/base/patternPlan/borrowReportSingle",
          params: {
            testNo: row.factTestValue,
            itemName: row.itemName,
            supplyCode: this.topData.supplyCode,
            singleDeterminant: row.singleDeterminant
          },
        }).then(res => {
          if (res.data.code === "200") {
            row.lineReport = true
            row.factTestValue = res.data.data
          } else {
            this.warning({
              // 提示
              title: h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'),
              message: res.data.msg,
              // 确定
              confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
              callback: () => {
                row.factTestValue = ""
              }
            })
          }
          this.closeLoading()
        })
      }
    },
    //清除已经填入的报告号
    clearFactTestValue(row) {
      row.factTestValue = ""
      row.lineReport = false
    },
    //查询单行报告单号
    searchFactTestValue(row) {
      if (row.factTestValue === "" || !row.factTestValue) {
        // 请先填写报告号
        this.warning(h_i18n('32dcc67853ed6ae34a9f0d37ed2141ae'))
        return
      }
      if (row.factTestValue.toUpperCase().substring(0, 2) !== "HR") {
        // 报告号应该以HR开头
        this.warning(h_i18n('ef51542dd7d9f6d15dc28feb367f16df'))
        return;
      }
      // 报告查询中...
      this.startLoading(h_i18n('529ef70f117b975815aa43b4662f939a'))
      this.$http({
        method: "get",
        url: "/base/patternPlan/borrowReportSingle",
        params: {
          testNo: row.factTestValue,
          itemName: row.itemName,
          supplyCode: this.topData.supplyCode,
          singleDeterminant: row.singleDeterminant
        },
      }).then(res => {
        if (res.data.code === "200") {
          row.lineReport = true
          row.factTestValue = res.data.data
        } else {
          this.warning({
            // 提示
            title: h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'),
            message: res.data.msg,
            // 确定
            confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
            callback: () => {
              row.factTestValue = ""
            }
          })
        }
        this.closeLoading()
      })
    },
    equipmentTypeChange(row) {
      //先不做没接口equipmentTypeId
      row.equipmentModel = ""
      if (row.equipmentTypeId) {
        this.$http({
          method: "GET",
          url: "/base/patternPlan/selectEquipmentInfoList",
          params: {
            tool: row.equipmentTypeId,
          },
        }).then(res => {
          if (res.data.code === "200") {
            this.toolTypeList = res.data.data
          }
        })

      }
    },
    checkTypeM(value) {
      switch (value) {
        case 1104:
          // 新品标准检
          return h_i18n('07776c59765079b72e7b52cf69d7724c')
        case 1105:
          // 新品免检
          return h_i18n('860c31139e636c2fc05e6dc5faf071bf')
        case 1106:
          // 新品加速检
          return h_i18n('aaedacb2e922bd7a5b98f05e4e6c06f6')
        case 1141:
          // 新品停检
          return h_i18n('6af02ad416e5589fcc3fcb9e89d30e31')
        default:
          return ""
      }
    },
    supplyCheckM(value) {
      switch (value) {
        case 1010:
          return "AQC"
        case 1011:
          return "BQC"
        case 1012:
          return "RQC"
        case 1153:
          return "LQC"
        default:
          return ""
      }
    },
    /**
     * 把数据从query上取出来
     * 配置需要查询的杂项
     */
    async queryToList() {
      // 数据处理中...
      this.startLoading(h_i18n('acb3aec4d12f6ca06a1e45302030cdb1'))
      let baseProjectCategoryCustom11 = [1055, 1056, 1057, 1059, 1060, 1061, 1155, 1376, 1377, 1378, 1379]
      this.dataTable = JSON.parse(this.$route.query.data)
      let list1 = await this.selectOtherData(12)
      let list2 = await this.selectOtherData(101)
      this.projectCategory = [...list1, ...list2]
      this.projectCategoryCustom = this.projectCategory.filter(v => baseProjectCategoryCustom11.includes(v.valueId))
      this.importance = await this.selectOtherData(13)
      this.inspectionLevel = await this.selectOtherData(15)
      this.specialNumberBasisList = await this.specialNumberBasis(this.dataTable.mtlNo)
      await this.getCheckInfoDetail()
      this.registerToListen()
    },

    /**
     * 查询重要性，检验类别，判别水平
     * @param id
     */
    selectOtherData(id) {
      return this.$http({
        method: "get",
        url: "/base/basicData/listBaseValues",
        params: {valueTypeId: id},
      }).then((res) => {
        if (res.data.code === "200") {
          return res.data.data
        } else {
          this.closeLoading()
          return Promise.reject(res.data.msg)
        }
      }).catch((err) => {
        this.closeLoading()
        this.error(err)
        this.$router.back()
      });
    },
    /**
     * 验收记录明细查询
     */
    getCheckInfoDetail() {
      this.tableLoading = true
      this.$http({
        method: "GET",
        url: "/base/patternPlan/searchPatternPlanDetail",
        params: {
          patternPlanId: this.dataTable.patternPlanId,
        },
      }).then((res) => {
        if (res.data.code === "200") {
          if (res.data.data.patternPlanNew) {
            this.topData = res.data.data.patternPlanNew;
          } else {
            // 明细查询失败
            this.info(h_i18n('ceded7c08d6ac5cbc388ce6648990504'))
            return
          }
          if (res.data.data.patternPlanDetails) {
            this.fileUploadToOss.filList = []
            this.fileUploadToOss.picList = []
            if (this.topData.fileUuidSize) {
              let picUrlList = this.topData.fileUuidSize.split(",")
              let picNameList = this.topData.fileNameSize ? this.topData.fileNameSize.split(",") : []

              this.fileUploadToOss.picList = picUrlList.map((v, i) => {
                return {
                  filePath: v,
                  fileName: picNameList[i] ? picNameList[i] : `computer${i}`
                }
              })
            }
            if (this.topData.fileUuidThirdReport) {
              let filUrlList = this.topData.fileUuidThirdReport.split(",")
              let filNameList = this.topData.fileNameThirdReport ? this.topData.fileNameThirdReport.split(",") : []

              this.fileUploadToOss.filList = filUrlList.map((v, i) => {
                return {
                  filePath: v,
                  fileName: filNameList[i] ? filNameList[i] : `computer${i}`
                }
              })
            }
            this.deviceTypeList = res.data.data.equipmentTypes
            //先处理数据
            this.checkTableList = res.data.data.patternPlanDetails.map(v => {
              let arr = []
              if (v.dataType === "计量型") {
                if (v.factTestValue) {
                  arr = v.factTestValue.split(",").map((value, index) => ({id: index, text: value.replaceAll("$£$", ","), check: false}))
                }
                if (v.patternNo && arr.length !== parseInt(v.patternNo)) {
                  let cc = parseInt(v.patternNo) > 13 ? 13 : parseInt(v.patternNo)
                  for (let i = arr.length; i < cc; i++) {
                    arr.push({id: i, text: "", check: false})
                  }
                }
              }
              let objImportance = this.importance.filter(value => value.valueId.toString() === v.importanceProperty)[0]
              let objInspectionLevel = this.inspectionLevel.filter(value => value.valueId === v.deterLevel)[0]
              let objProjectCategory = this.projectCategory.filter(value => value.valueId === v.itemCode)[0]
              return {
                ...v,
                singleDeterminant: v.singleDeterminant ? v.singleDeterminant : "P",
                theNumberDecisionsList: arr,
                itemCodeName: objProjectCategory ? objProjectCategory.valueName : "",
                importancePropertyName: objImportance ? objImportance.valueName : "",
                deterLevelName: objInspectionLevel ? objInspectionLevel.valueName : "",
                lineReport: false
              }
            })

            //查出自定义项来
            let checkTableListQBSelf = this.checkTableList.filter(v => !v.testItemId)
            //按企标分类的列表
            let checkTableListQB = []
            let treeCopyList = []
            let index = 0
            //企标列表--按企标分类
            this.specialNumberBasisList.forEach(value => {
              let baseList = []
              let treeCopyItem = []
              let treeIndexItem = []
              if (value.templateName !== "自定义企标") {
                baseList.push({frontKey: "QB", templateCode: value.templateCode, templateName: value.templateName})
                baseList.push(...value.list.map(data => {
                  index++
                  treeIndexItem.push(index)
                  return {...this.checkTableList.filter(v => v.testItemId === data.mcodDetailId)[0], frontKey: "ITEM_OLD", frontIndex: index, reportMarkLoading: false, experimentalLoading: false}
                }))
                treeCopyItem.push({frontKey: "QB", templateCode: value.templateCode, templateName: value.templateName, list: treeIndexItem, min: Math.min(...treeIndexItem), max: Math.max(...treeIndexItem)})
              }
              checkTableListQB.push(...baseList)
              treeCopyList.push(...treeCopyItem)
            })

            this.treeCopyList = treeCopyList

            let array = []
            this.specialNumberBasisList.forEach(v => {
              v.list.forEach(value => array.push(value.mcodDetailId))
            })

            let QB = []

            let arr = this.checkTableList.filter(v => !array.includes(v.testItemId) && v.testItemId)

            if (checkTableListQB.filter(v => v.frontKey === "专用号依据自定义企标").length === 0 && arr.length > 0) {
              // 专用号依据自定义企标
              QB.push({frontKey: "QB", templateCode: h_i18n('69e95a695a6462a0e4d4daf2ecad4420'), templateName: h_i18n('69e95a695a6462a0e4d4daf2ecad4420')})
              arr.forEach(v => {
                index++
                QB.push({...v, frontKey: "ITEM_OLD", frontIndex: index, reportMarkLoading: false})
              })
            }

            checkTableListQB.push(...QB)

            if (checkTableListQBSelf.length > 0) {
              // 自定义企标
              checkTableListQB.push({frontKey: "QB_NEW", templateCode: h_i18n('e9c40129c2e16b116d1086da081d69d2'), templateName: h_i18n('e9c40129c2e16b116d1086da081d69d2')})
              checkTableListQB.push(...checkTableListQBSelf.map(v => {
                index++
                return {...v, frontKey: "ITEM_NEW", frontIndex: index, reportMarkLoading: false}
              }))
            }

            if (checkTableListQB.some(v => v.singleDeterminant === "F")) {
              this.testConclusion = "F"
            }

            this.checkTableList = checkTableListQB

            if (this.checkTableList.some(v => v.singleDeterminant === "F")) {
              this.defaultTag = true
            }
            this.tableLoading = false
            this.testResults()
          } else {
            this.tableLoading = false
            // 专用号依据中不存在入厂检验项目
            this.error(h_i18n('6cc74bbf51ae66bac1b2db0d205e1533'));
          }
        }else {
          this.warning({
              // 提示
              title: h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'),
              message: res.data.msg,
              // 确定
              confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
              callback: () => {
                this.$router.back()
              }
            })
        }
      }).catch(err=>{
        
      }).finally(()=>{
        this.tableLoading = false
        this.closeLoading()
      })
    },
    /**
     * 查询专用号依据
     * /unload/batchapp/findExamine
     * 这个接口和查明系的接口的对应规则是itemId和mcodDetailId
     */
    specialNumberBasis(mtlNo) {
      return this.$http({
        method: "GET",
        url: "/base/patternPlan/findExamine?mtlNo=" + mtlNo,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
      }).then(value => {
        if (value.data.code === "200") {
          return value.data.data.map(data => {
            if (data.template.templateName && data.template.templateName === "入厂通用要求") {
              return {
                // 入厂通用要求
                templateCode: data.template.templateCode ? data.template.templateCode : h_i18n('74dab4837fab86d193d7c6ef823c215b'),
                // 自定义企标
                templateName: data.template.templateName ? data.template.templateName : h_i18n('e9c40129c2e16b116d1086da081d69d2'),
                list: data.details.map(v => ({mcodDetailId: v.mcodDetailId}))
              }
            } else {
              return {
                // 自定义企标
                templateCode: data.template.templateCode ? data.template.templateCode : h_i18n('e9c40129c2e16b116d1086da081d69d2'),
                // 自定义企标
                templateName: data.template.templateName ? data.template.templateName : h_i18n('e9c40129c2e16b116d1086da081d69d2'),
                list: data.details.map(v => ({mcodDetailId: v.mcodDetailId}))
              }
            }
          })
        } else {
          // 查询专用号依据失败
          this.error(h_i18n('8a920f7250a218cd16f94746c1b8e864'))
          return []
        }
      })
    },
    /**
     * 8个判定数
     */
    theNumberDecisions(max) {
      let obj = {}
      let arr = []
      max = parseInt(max) > 13 ? 13 : parseInt(max)
      for (let i = 0; i < max; i++) {
        obj.id = i
        obj.text = ""
        arr.push(JSON.parse(JSON.stringify(obj)))
      }
      return JSON.parse(JSON.stringify(arr))
    },

    /**
     * 删除自定义项
     * @param index frontIndex标记
     */
    removeCustomObject(index) {
      this.checkTableList = this.checkTableList.filter(v => v.frontIndex !== index)
      //是否要删除分类
      if (!this.checkTableList.some(v => v.frontKey === "ITEM_NEW")) {
        this.checkTableList = this.checkTableList.filter(v => v.frontKey !== "QB_NEW")
      }
    },

    /**
     * 添加自定义项
     */
    async addCustomObject() {
      this.listToZeroList()
      let frontIndex
      if (this.checkTableList[this.checkTableList.length - 1].frontIndex) {
        frontIndex = parseInt(this.checkTableList[this.checkTableList.length - 1].frontIndex) + 1
      } else {
        frontIndex = parseInt(this.checkTableList[this.checkTableList.length - 2].frontIndex) + 1
      }

      let importanceIndex = this.importance[0].valueId
      let inspectionLevelIndex = this.inspectionLevel[0].valueId
      let projectCategoryIndex = this.projectCategory[0].valueId
      let obj = {
        frontKey: "ITEM_NEW",
        frontIndex: frontIndex,
        itemName: "",
        itemCode: projectCategoryIndex,
        remark: "",
        // 计数型
        dataType: h_i18n('f96c63cc7406f89d0e2fe171d4d7c3b6'),
        patternNo: "",
        acDeterminant: "",
        reDeterminant: "",
        theNumberDecisionsList: "",
        factTestValue: "",
        importanceProperty: importanceIndex.toString(),
        deterLevel: inspectionLevelIndex.toString(),
        rqlProperty: "",
        testAreaMin: "",
        testAreaMax: "",
        unit: "",
        singleDeterminant: "P",
        batchDetailId: "",
        uuid: this.topData.uuid,
        checkMethod: "",
        lineReport: false
      }

      if (this.checkTableList.some(v => v.frontKey === "QB_NEW")) {
        this.checkTableList.push(obj)
      } else {
        // 自定义企标
        this.checkTableList.push({frontKey: "QB_NEW", templateCode: h_i18n('e9c40129c2e16b116d1086da081d69d2'), templateName: h_i18n('e9c40129c2e16b116d1086da081d69d2')})
        this.checkTableList.push(obj)
      }
    },
    /**
     * 隐藏和禁用复选框
     */
    disabledCheckBox({row}) {
      if (row.testReportType === "Y" || row.reportMark === 'Y') {
        return false
      }
      return row.frontKey !== "QB" && !row.reportMark;
    },
    hideCheckBox({row}) {
      return row.frontKey !== "QB";
    },
    listToZeroList() {
      this.checkTableList = Array.from(JSON.parse(JSON.stringify(this.dataTableList)))
    },

    /**
     * 注册监听·
     *
     */
    registerToListen() {
      //监听元数据驱动列表视图更新
      this.$watch(() => this.checkTableList, () => {
        this.dataTableList = Array.from(JSON.parse(JSON.stringify(this.checkTableList)))
        this.deleteSign = this.dataTableList.some(v => v.frontKey === "QB_NEW");
        let timeout = setTimeout(() => {
          this.config = this.deleteSign
          clearTimeout(timeout)
        })
        this.handleSelection = []
      }, {deep: true, immediate: true})

      //监听借用报告list自动带出功能
      this.$watch(() => this.borrowingReport.borrowingReportList, () => {
        if (this.borrowingReport.borrowingReportList.length > 0) {
          //点击弹出框选择的
          if (this.borrowingReport.text.includes(".")) {
            let arr = this.borrowingReport.text.split(".")
            //在查询的数据中存在text中的值
            if (this.borrowingReport.borrowingReportList.some(v => v.testNo === arr[1] && v.mtlNo === arr[0])) {
              this.borrowingReport.disabled = false
            }
          } else {
            let arr = this.borrowingReport.borrowingReportList.filter(v => v.testNo === this.borrowingReport.text)
            if (arr.length > 0) {
              if (arr.length === 1) {
                this.borrowingReport.text = arr[0].mtlNo + '.' + arr[0].testNo
              }
              this.borrowingReport.disabled = false
            }
          }
        }

        if (this.borrowingReport.text.includes(".")) {
          let arr = this.borrowingReport.text.split(".")
          //在查询的数据中存在text中的值
          this.borrowingReport.disabled = !this.borrowingReport.borrowingReportList.some(v => v.testNo === arr[1] && v.mtlNo === arr[0]);
        } else {
          this.borrowingReport.disabled = !this.borrowingReport.borrowingReportList.some(v => v.testNo === this.borrowingReport.text);
        }
      })
      //监听选中数据--驱动借用报告
      this.$watch(() => this.handleSelection, () => {
        this.borrowingReportActuator(this.handleSelection)
        this.benchmarkingTheMother(this.handleSelection)
        this.putOnExperiment(this.handleSelection)
      }, {deep: true, immediate: true})

    },
    /**
     * 处理两个查询
     * *******************************************************************************
     */
    myBlur(v) {
      if (!this.planBlur) {
        this.plan[v] = false;
      }
    },
    myFocus3(v) {
      this.planBlur = false
      if (this.searchData.mtlNo.length >= 4) {
        this.plan[v] = true;
      }
    },
    // 供应商获取焦点
    myFocus4(v) {
      this.planBlur = false;
      if (this.searchData.supplyCode.length >= 2) {
        this.plan[v] = true;
      }
    },
    /**
     * 专用号模糊查询
     */
    mtlNoChange() {
      this.planBlur = false;
      if (this.http.mtlSearchHttp) this.http.mtlSearchHttp.cancel()
      this.http.mtlSearchHttp = axios.CancelToken.source()
      if (this.searchData.mtlNo.length < 4) {
        this.plan.showMtlPlan = false;
      } else {
        this.loading.mtlLoading = true;
        this.plan.showMtlPlan = true;
        this.$http({
          method: "POST",
          url: "/base/basicData/searchMaterielList",
          headers: {"content-type": "application/json"},
          data: {
            mtlNo: this.searchData.mtlNo,
          },
          cancelToken: this.http.mtlSearchHttp.token
        }).then((res) => {
          this.benchmarkingTheMotherPlan.mtlSelectList = res.data.data;
          this.loading.mtlLoading = false;
        }).catch(e => {
        });
      }
    },
    clickMtlNo(row) {
      this.searchData.mtlNo = row.mtlNo;
      this.plan.showMtlPlan = false;
    },
    clearMtlNo() {
      this.plan.showMtlPlan = false;
    },
    supplyCodeChange() {
      this.planBlur = false;
      if (this.http.supplySearchHttp) this.http.supplySearchHttp.cancel()
      this.http.supplySearchHttp = axios.CancelToken.source()
      if (this.searchData.supplyCode.length < 2) {
        this.plan.showSupplyPlan = false;
      } else {
        this.loading.supplyLoading = true;
        this.plan.showSupplyPlan = true;
        this.$http({
          method: "post",
          url: "/base/basicData/searchSupplierList",
          headers: {"content-type": "application/json"},
          data: {
            supplyCode: this.searchData.supplyCode,
          },
          cancelToken: this.http.supplySearchHttp.token
        }).then((res) => {
          this.supplyCodeList = res.data.data;
          this.loading.supplyLoading = false;
        }).catch(e => {
        });
      }
    },
    clickSupplierCode(row) {
      this.planBlur = true;
      this.searchData.supplyCode = row.supplyCode;
      this.plan.showSupplyPlan = false;
    },
    /**
     * 处理两个查询结束
     * *******************************************************************************
     */
    /**
     * 判断输入框的禁用规则
     */
    isDisabled(row) {
      if (row.reportMark) {
        return true
      }
      if (row.testReportType === "Y") {
        return true
      }
    },
    /**
     * 删除下实验
     */
    deleteExperimentalReport(row) {
      row.experimentalLoading = true
      this.$http({
        method: "GET",
        url: "/base/patternPlan/deleteTestReportById",
        params: {
          planDetailId: row.planDetailId,
          testNo: row.factTestValue
        },
      }).then(res => {
        row.experimentalLoading = false
        if (res.data.code === "200") {
          this.getCheckInfoDetail()
        } else {
          this.error(res.data.msg)
        }
      }).catch(e => {
        row.experimentalLoading = false
        // 服务异常，删除失败
        this.error(h_i18n('9f73c6c505b78495955c3026c232ac56'))
      })
    },
    /**
     * 删除借用报告
     */
    deleteBorrowingReport(row) {
      row.reportMarkLoading = true
      this.$http({
        method: "GET",
        url: "/base/patternPlan/deleteReportById",
        params: {
          planDetailId: row.planDetailId
        },
      }).then(res => {
        row.reportMarkLoading = false
        if (res.data.code === "200") {
          this.getCheckInfoDetail()
        } else {
          this.error(res.data.msg)
        }
      }).catch(e => {
        row.reportMarkLoading = false
        // 服务异常，删除失败
        this.error(h_i18n('9f73c6c505b78495955c3026c232ac56'))
      })
    },

    //对标母本执行判断
    benchmarkingTheMother(array) {
      this.benchmarkingTheMotherPlan.benchmarkingTheMotherType = array.length <= 0;
    },

    //下达实验
    putOnExperiment(array) {
      if (array.length > 0) {
        this.putOnExperimentPlan.disabled = !array.every(v => v.itemCode === 1058);
      } else {
        this.putOnExperimentPlan.disabled = true
      }
    },

    /**
     * 借用报告的操作
     * 勾选明细项后执行
     */
    borrowingReportActuator(array) {
      if (array.length === 0) {
        this.borrowingReport.text = ""
        this.borrowingReport.borrowingReportList = []
        this.borrowingReport.borrowingReportSign = false
        // 请至少选择一项检验类别标记为'性能'的数据
        this.borrowingReport.borrowingReportPlaceholder = h_i18n('bdb47a855ebe341be9353e67f7ae8832')
      } else if (!array.every(v => v.itemCode === 1058)) {
        this.borrowingReport.text = ""
        this.borrowingReport.borrowingReportList = []
        this.borrowingReport.borrowingReportSign = false
        // 借用报告只能选择检验类别标记为'性能'的数据
        this.borrowingReport.borrowingReportPlaceholder = h_i18n('48cd68d5f250a9d40c4791ac96f673c4')
      } else {
        this.borrowingReport.text = ""
        this.borrowingReport.borrowingReportList = []
        this.borrowingReport.borrowingReportSign = true
        // 请至少输入4位进行模糊查询
        this.borrowingReport.borrowingReportPlaceholder = h_i18n('63701be2d536aa3632632698736f5034')
      }
    },

    /**
     * 借用报告搜索
     * @param text
     */
    borrowingReportSelect(text) {
      if (text.includes(".")) {
        text = text.split(".")[1]
      }
      if (text.length >= 4) {
        this.borrowingReport.disabled = true
        this.borrowingReport.plane = false
        if (this.reduceExpenditure.borrowingReport) clearTimeout(this.reduceExpenditure.borrowingReport)

        this.reduceExpenditure.borrowingReport = setTimeout(() => {
          if (this.http.borrowingReportHttp) this.http.borrowingReportHttp.cancel()
          this.borrowingReport.show = true
          this.borrowingReport.tableLoading = true
          this.http.borrowingReportHttp = axios.CancelToken.source();
          this.$http({
            method: "GET",
            url: "/base/patternPlan/searchBorrowTask",
            params: {
              supplyCode: this.topData.supplyCode,
              materielCategoryId: this.topData.materielCategoryId,
              testNo: text,
              planDetailIds: this.handleSelection.map(v => v.planDetailId).join(",")
            },
            cancelToken: this.http.borrowingReportHttp.token,
          }).then(res => {
            if (res.data.code === "200") {
              this.borrowingReport.borrowingReportList = res.data.data ? res.data.data : []
            } else {
              // 借用报告查询失败
              this.error(h_i18n('717b233da4078a7280b1c237e1321aa6') + res.data.msg)
            }
            this.borrowingReport.tableLoading = false
          }).catch(e => {
            this.borrowingReport.tableLoading = true
          })
        }, 300)
      } else {
        this.borrowingReport.show = false
      }
    },
    /**
     * 借用报告前判断样本大小AcRe
     * @param list
     */
    beforeBorrowingReport(list) {
      return !list.every(v => {
        if (!v.patternNo) {
          // 请在借用报告前填写样本大小
          this.info(h_i18n('c3442a98d1f5840808dc4b663834d1fe'))
          return false
        }
        if (!v.acDeterminant) {
          // 请在借用报告前填写Ac
          this.info(h_i18n('b95edfc76d303b096c73f28caeb16cb0'))
          return false
        }
        if (!v.reDeterminant) {
          // 请在借用报告前填写Re
          this.info(h_i18n('5b969788b1e6d79b5b759540c191b50c'))
          return false
        }
        return true
      })
    },

    /**
     * 借用报告。借用
     */
    async chooseBorrowingReport(text) {
      //借用报告前判断样本大小AcRe
      if (this.beforeBorrowingReport(this.handleSelection)) return false
      this.borrowingReport.loading = true
      let testNo = text.split(".")
      if (!await this.saveSubmit(false)) return false
      await this.$http({
        method: "GET",
        url: "/base/patternPlan/borrowReport",
        params: {
          testNo: testNo[1],
          planDetailIds: this.handleSelection.map(v => v.planDetailId).join(",")
        },
      }).then(res => {
        if (res.data.code === "200") {
          this.getCheckInfoDetail()
        } else {
          // 借用报告失败，
          this.error(h_i18n('2d6ead46fdf9325d0db4dbefeecaa1d3') + res.data.msg)
        }
        this.borrowingReport.loading = false
      }).catch(e => {
        this.borrowingReport.loading = false
      })
    },

    /**
     * 下达实验
     */
    putOnExperimentM() {
      let obj = {
        // 样本大小
        patternNo: h_i18n('9e23b61ce24cfada6fea1cdc2277976c'),
        acDeterminant: "Ac",
        reDeterminant: "Re"
      }
      let list = Object.keys(obj)
      for (let i = 0; i < this.handleSelection.length; i++) {
        for (let j = 0; j < list.length; j++) {
          if (this.handleSelection[i][list[j]] === "" || !this.handleSelection[i][list[j]]) {
            // 在；行中，；不允许为空
            this.warning(`${h_i18n('241d47a3ee97f044c1f043b9ea81855b')}${this.handleSelection[i].frontIndex}${h_i18n('8b2464809b09351adc8af1946f86b62c')}${obj[list[j]]}${h_i18n('17a4887790e7513f61d977767e0e172e')}`)
            return
          }
        }
      }
      this.info({
        // 提示
        title: h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'),
        // 下达试验前,需要填写所有检测项的'样本大小','AC','RE'值,且系统会自动保存当前数据.<br/>是否确定保存当前数据并下达试验?
        message: h_i18n('017efda9fa54e22417db0fa1f3dae3ac'),
        // 确定
        confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
        // 取消
        cancelButtonText: h_i18n('625fb26b4b3340f7872b411f401e754c'),
        callback: async (action) => {
          if (action === "confirm") {
            //选中的frontIndex列表
            let indexList = this.handleSelection.map(v => v.frontIndex)

            let enterpriseList = this.treeCopyList.map(v => ({...v, nextList: []}))
            for (let i = 0; i < enterpriseList.length; i++) {
              for (let j = 0; j < indexList.length; j++) {
                let min = this.treeCopyList[i].min
                let max = this.treeCopyList[i].max
                if (indexList[j] >= min && indexList[j] <= max) {
                  enterpriseList[i]["nextList"].push(indexList[j])
                }
              }
            }
            //向上遍历找到分类的企标
            enterpriseList.map(v => {
              delete v.min
              delete v.max
              delete v.list
              delete v.frontKey
            })
            enterpriseList = enterpriseList.filter(value => (value.nextList.length > 0))

            enterpriseList = enterpriseList.map(v => {
              let obj = {...v}
              obj.list = v.nextList.map(value => {
                let oc = this.handleSelection.filter(va => va.frontIndex === value)[0]
                return {
                  itemName: oc.itemName,
                  planDetailId: oc.planDetailId,
                  testItemId: oc.testItemId
                }
              })
              delete obj.nextList
              return obj
            })

            let planDetailIds = []

            for (let i = 0; i < enterpriseList.length; i++) {
              planDetailIds.push(...enterpriseList[i].list)
            }

            await this.saveSubmit()

            await this.$router.push({
              name: "ExperimentalOrder",
              query: {
                name: this.name,
                nickName: this.$route.query.nickName,
                data: JSON.stringify({
                  patternPlanId: this.topData.patternPlanId,
                  planDetailIds: planDetailIds.map(v => v.planDetailId).join(","),
                  allList: enterpriseList
                })
              }
            })
          }
        }
      })
    },
    /**
     * 选择单项借用报告
     */
    selectBorrowingReportItem(row) {
      this.borrowingReport.text = row.mtlNo + "." + row.testNo
      this.borrowingReport.show = false
      this.borrowingReport.disabled = false
    },
    /**
     * 借用报告弹出框隐藏判断
     */
    borrowingReportBlur() {
      if (!this.borrowingReport.plane) {
        this.borrowingReport.show = false
      }
    },


    /**
     * 查看封样单
     * @param sealedSamplesId
     */
    sampleSealingSheet(sealedSamplesId) {
      if (null == sealedSamplesId || sealedSamplesId === '' || !sealedSamplesId) {
        // 没有匹配的封样单!
        this.info(h_i18n('3044e7235e192323f508518407199171'));
      } else {
        window.location.href = "/basicdata/sealedSamples_detail?id=" + sealedSamplesId;
      }

    },

    inspectionUpdate() {
      this.postThisPageHeight()
    },


    /**
     * 手工同步专用号依据
     */
    manualSynchronizationOfSpecialNumberBasis() {
      this.info({
        // 提示
        title: h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'),
        // 更新后已录入检验数据会自动清除，请确认是否更新
        message: h_i18n('c2bf37c0c33d5fe78794ebc2f566489c'),
        // 确定
        confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
        // 取消
        cancelButtonText: h_i18n('625fb26b4b3340f7872b411f401e754c'),
        callback: (action) => {
          if (action === "confirm") {
            // 手工同步专用号依据...
            this.startLoading(h_i18n('8e1ab5b979d5a681ce001a47dddf0644'))
            this.$http({
              method: "get",
              url: "/base/patternPlan/manualSyncDetail?patternPlanId=" + this.topData.patternPlanId,
            }).then(res => {
              this.closeLoading()
              if (res.data.success) {
                // 手工同步专用号依据成功
                this.success(h_i18n('9ee1785ebe08ad2dcd0e9af3e6c77f0b'))
                this.getCheckInfoDetail()
              } else {
                // 手工同步专用号依据失败
                this.error(h_i18n('20e3bc0dd657fa82089afd299a751195'))
              }
            // 手工同步专用号依据失败
            }, () => this.error(h_i18n('20e3bc0dd657fa82089afd299a751195')))
          }
        }
      })
    },


    /**
     * 文件下载
     */
    download(v,n) {
      if(v.includes('http')){
      window.open(v, "_black")
      }else{
        this.httpFile(
            {
              method: "get",
              url: '/base/fileDownload/downloadFile?filePath=' + v,
              headers: { "content-type": "application/json" },
            },n
          );
      }
    },

    downloadPDF(v,n) {
      if(v.includes('http')){
      window.open(v)
      }else{
        this.httpFile(
            {
              method: "get",
              url: '/base/fileDownload/downloadFile?filePath=' + v,
              headers: { "content-type": "application/json" },
            },n
          );
      }
    },


    /**
     * 合并列
     */
    arraySpanMethod(data) {
      if (data.row.frontKey === "QB" || data.row.frontKey === "QB_NEW") {
        if (data.$columnIndex === 0) {
          return {rowspan: 1, colspan: 29}
        }
        // if (data.$columnIndex === 0) {
        //   return {rowspan: 1, colspan: 0}
        // }
        if (data.$columnIndex > 1) {
          return {rowspan: 1, colspan: 0}
        }
      } else {
        if (data.$columnIndex === 8) {
          return {rowspan: 1, colspan: 13}
        }
        if (data.$columnIndex >= 9 && data.$columnIndex <= 20) {
          return {rowspan: 0, colspan: 1}
        }
      }
    },
    /**
     * 8个判定数判断最终结论 -factTestValue
     */
    theNumberDecisionsChange(row, obj) {
      if (!obj.text.trim()) {
        obj.text = ""
        return
      } else {
        if (obj.text !== "-") {
          if (!obj.text.includes(".")) {
            let re = new RegExp("^-?\\d*\\.?\\d+$")
            if (!re.test(obj.text)) {
              obj.text = obj.text.substring(0, obj.text.length - 1)
              return;
            }
          } else {
            if (obj.text.split(".").length > 2) {
              obj.text = obj.text.substring(0, obj.text.length - 1)
              return;
            } else {
              if (obj.text.split(".")[1]) {
                let re = new RegExp("^-?\\d*\\.?\\d+$")
                if (!re.test(obj.text)) {
                  obj.text = obj.text.substring(0, obj.text.length - 1)
                  return;
                }
              }
            }
          }
        }
      }
      let nowListLen = parseInt(row.patternNo)
      let arr = row.theNumberDecisionsList.slice(0, nowListLen)
      let singleDeterminantList = []
      arr.forEach(v => {
        if (parseFloat(v.text) < parseFloat(row.testAreaMin) || parseFloat(v.text) > parseFloat(row.testAreaMax)) {
          singleDeterminantList.push(false)
        } else {
          singleDeterminantList.push(true)
        }
      })
      if (singleDeterminantList.some(v => !v)) {
        row.singleDeterminant = "F"
      } else {
        row.singleDeterminant = "P"
      }
      row.factTestValue = arr.map(value => value.text).join(",")
      this.testResults()
    },

    factTestValueChange(obj) {
      if (!obj.factTestValue.trim()) {
        obj.factTestValue = ""
      } else {
        obj.factTestValue = obj.factTestValue.trim()
      }
    },

    /**
     * 复制
     */
    copy(data) {
      if (data) {
        let url = data;
        let oInput = document.createElement('input');
        oInput.value = url;
        document.body.appendChild(oInput);
        oInput.select(); // 选择对象;
        document.execCommand("Copy"); // 执行浏览器复制命令
        this.$message({
          // 复制成功
          message: h_i18n('20a495364a9fa0812a97d68215b093e4'),
          type: 'success'
        });
        oInput.remove()
      }
    },
    /**
     * 测试结果
     */
    testResults(row) {
      if (this.dataTableList.length !== 0) {
        let arr = this.dataTableList.filter(v => v.frontKey !== "QB").map(v => v.singleDeterminant === "F")
        if (arr.some(v => v)) {
          this.testConclusion = "F"
        } else {
          this.testConclusion = "P"
        }
      }
    },


    /**
     * 文件上传弹出面板
     */
    fileSelect(type) {
      this.fileList = []
      this.fileUploadToOss.fileChoose = true
      switch (type) {
        case "pic":
          this.fileUploadToOss.openPlan = "pic"
          this.fileList = this.fileUploadToOss.picList.map((v, i) => ({...v, status: "success", progress: 100, name: v.fileName})).filter(v => v.fileName)
          break;
        case "fil":
          this.fileUploadToOss.openPlan = "fil"
          this.fileList = this.fileUploadToOss.filList.map(v => ({...v, status: "success", progress: 100, name: v.fileName})).filter(v => v.fileName)
          break;
        case "fil2":
          this.fileUploadToOss.openPlan = "fil2"
          this.fileList = this.fileUploadToOss.fil2List.map(v => ({...v, status: "success", progress: 100, name: v.fileName})).filter(v => v.fileName)
          break;
      }
    },


    /**
     * 选择文件
     */
    chooseFile(file, fileList) {
      this.fileList = fileList
    },
    errorFile(str) {
      this.info(str)
    },
    /**
     * 删除文件
     */
    removeFile(file) {
      this.fileList = this.fileList.filter(v => v.uid !== file.uid)
    },


    /**
     * 多选
     */
    handleSelectionChange(row) {
      this.handleSelection = row.records.filter(v => v.frontKey !== "QB")
    },
    /**
     * 行样式
     */
    rowClassName({row}) {
      if (row.testReportType === "Y") {
        return "line-color1"
      } else if (row.reportMark === 'Y') {
        return "line-color2"
      } else {
        return ""
      }
    },
    /**
     * 提交前验证
     */
    submitVerify() {

      //将默认的和自定义的分开验证
      let defaultList = this.dataTableList.filter(v => v.frontKey === "ITEM_OLD")
      let customList = this.dataTableList.filter(v => v.frontKey === "ITEM_NEW")

      //需要检验的集合
      let defaultNeedDetectMap = {
        // 样本大小
        patternNo: h_i18n('9e23b61ce24cfada6fea1cdc2277976c'),
        acDeterminant: "Ac",
        reDeterminant: "Re",
      }
      let customNeedDetectMap = {
        // 检验项目
        itemName: h_i18n('222c0f1a6341c9df01ca58fc982db93b'),
        // 技术（标准）要求
        remark: h_i18n('afb44627fabcf435b4633f1f6bd12eb3'),
        // 样本大小
        patternNo: h_i18n('9e23b61ce24cfada6fea1cdc2277976c'),
        acDeterminant: "Ac",
        reDeterminant: "Re",
        rqlProperty: "RQL",
        testAreaMin: "Min",
        testAreaMax: "Max",
        // 单位
        unit: h_i18n('f2996845b6bf0a07fe26f74f35e42ebe')
      }
      //先验证默认
      try {
        defaultList.forEach(v => {
          if (v.testReportType !== "Y" && v.reportMark !== "Y") {
            for (let o in defaultNeedDetectMap) {
              if (!v[o]) {
                // 在第；条明细项中，“；”不允许为空
                throw new Error(`${h_i18n('6ab57a09184558bd18fc3368be82e795')}${v.frontIndex}${h_i18n('2b65f4e5a291d73aef8e5f274c05ded2')}${defaultNeedDetectMap[o]}${h_i18n('f48ab54f727e512ea609812d299c7441')}`)
              }
            }
            //实测值不允许为空时放开
            if (v.dataType === "计量型") {
              v.theNumberDecisionsList.forEach(value => {
                if (value.text === "") {
                  // 在第；条明细项中，“实测值；”不允许为空
                  throw new Error(`${h_i18n('6ab57a09184558bd18fc3368be82e795')}${v.frontIndex}${h_i18n('a03c84b92879bf717cc4a801479f78db')}${value.id + 1}${h_i18n('f48ab54f727e512ea609812d299c7441')}`)
                }
              })
            } else {
              if (!v.factTestValue) {
                // 在第；条明细项中，“实测值”不允许为空
                throw new Error(`${h_i18n('6ab57a09184558bd18fc3368be82e795')}${v.frontIndex}${h_i18n('a88bd51cba1928b44b3d002a0e6f1a49')}`)
              }
            }
          }
        })
        customList.forEach(v => {
          for (let o in customNeedDetectMap) {
            if (!v[o]) {
              // 在第；条明细项中，“；”不允许为空
              throw new Error(`${h_i18n('6ab57a09184558bd18fc3368be82e795')}${v.frontIndex}${h_i18n('2b65f4e5a291d73aef8e5f274c05ded2')}${customNeedDetectMap[o]}${h_i18n('f48ab54f727e512ea609812d299c7441')}`)
            }
          }
          //实测值不允许为空时放开
          if (v.dataType === "计量型") {
            v.theNumberDecisionsList.forEach(value => {
              if (value.text === "") {
                // 在第；条明细项中，“实测值；”不允许为空
                throw new Error(`${h_i18n('6ab57a09184558bd18fc3368be82e795')}${v.frontIndex}${h_i18n('a03c84b92879bf717cc4a801479f78db')}${value.id + 1}${h_i18n('f48ab54f727e512ea609812d299c7441')}`)
              }
            })
          } else {
            if (!v.factTestValue) {
              // 在第；条明细项中，“实测值”不允许为空
              throw new Error(`${h_i18n('6ab57a09184558bd18fc3368be82e795')}${v.frontIndex}${h_i18n('a88bd51cba1928b44b3d002a0e6f1a49')}`)
            }
          }
        })
        if (this.fileUploadToOss.picList.length < 1 && this.testConclusion === "F") {
          // 请至少上传一份尺寸见证资料
          throw new Error(h_i18n('ef3ada7103e6f2a15540beb4bfc344ef'))
        }
        //验证时放开就行
        // if (!this.fileUploadToOss.fil.fileUuid) {
        //   throw new Error("请上传其他见证性资料")
        // }
        this.dataTableList.forEach(v => {
          if (v.testReportType === "Y") {
            if (v.testAdminAuditSign !== "正常" && v.testAdminAuditSign !== "检测-已发布") {
              // 实验报告状态为 正常 或 检测-已发布 才能提交
              throw new Error(h_i18n('33d74146b3d137addaa23acd51bdfa62'))
            }
          }
        })
        return true
      } catch (e) {
        // 校验出错
        this.info(e.message ? e.message : h_i18n('031922c203b3bc756072a8df7c950e80'))
        return false
      }
    },
    /**
     * 样本大小
     * @param row
     */
    patternNoInput(row) {
      if (row.patternNo !== "/" && row.patternNo) {
        //新的匹配逻辑 正整数
        let re = new RegExp("^[1-9]\\d*$")
        if (!re.test(row.patternNo)) {
          // 样本大小只允许输入正整数
          this.info(h_i18n('88c46af36b0d2757d1fe49c7172bc43b'))
          row.patternNo = ""
        } else {
          row.theNumberDecisionsList = this.theNumberDecisions(row.patternNo)
        }
      }
    },
    /**
     * 最大值最小值
     */
    minAndMax(row, type) {
      //新的匹配逻辑
      if (row[type]) {
        let re = new RegExp("^-?\\d*\\.?\\d+$")
        if (!re.test(row[type])) {
          // 范围只允许输入数字
          this.info(h_i18n('79a2a6df8127635756158fb56d7a90c7'))
          row[type] = ""
        } else {

        }
      }
      if (type === "testAreaMin") {
        if (row["testAreaMax"]) {
          if (parseFloat(row["testAreaMax"]) < parseFloat(row["testAreaMin"])) {
            // 最小值不得大于最大值
            this.info(h_i18n('fe17e7b3f899b4acc03a038a237b6d94'))
            row[type] = ""
            return
          }
        }
      }
      if (type === "testAreaMax") {
        if (row["testAreaMin"]) {
          if (parseFloat(row["testAreaMax"]) < parseFloat(row["testAreaMin"])) {
            // 最大值不得小于最小值
            this.info(h_i18n('59f315d9a2255285a7653038cba83e03'))
            row[type] = ""
          }
        }
      }
    },
    /**
     * Ac  Re
     */
    acDeterminantInput(row) {
      let re = new RegExp("^[0-9]\\d*|[1-9]\d*\.\d*|0\.\d*[1-9]\d*|0?\.0+|0$")
      if (row.acDeterminant) {
        if (!isNaN(row.acDeterminant)) {
          if (!re.test(row.acDeterminant)) {
            // Ac只允许输入非负数数字
            this.info(h_i18n('ced4ed044a24f563200b495c2f0ed5b0'))
            row.acDeterminant = ""
          }
        } else {
          // Ac只允许输入非负数数字
          this.info(h_i18n('ced4ed044a24f563200b495c2f0ed5b0'))
          row.acDeterminant = ""
        }
      }
      if (row.acDeterminant.split("").filter(v => v === ".").length > 1) {
        // Ac只允许输入一位小数点
        this.info(h_i18n('58762fdd8956a31648243d7d90df936c'))
        row.acDeterminant = ""
      }
    },
    reDeterminantInput(row) {
      let re = new RegExp("^[0-9]\\d*|[1-9]\d*.\d*|0.\d*[1-9]\d*|0?.0+|0$")
      if (row.reDeterminant) {
        if (!isNaN(row.reDeterminant)) {
          if (!re.test(row.reDeterminant)) {
            // Re只允许输入非负数数字
            this.info(h_i18n('5d633b94f5bd6e73e71ef9320aeb8064'))
            row.reDeterminant = ""
          }
        } else {
          // Re只允许输入非负数数字
          this.info(h_i18n('5d633b94f5bd6e73e71ef9320aeb8064'))
          row.reDeterminant = ""
        }
      }
      if (row.reDeterminant.split("").filter(v => v === ".").length > 1) {
        // Re只允许输入一位小数点
        this.info(h_i18n('47a46803ec9ac91003b2e8e06d604782'))
        row.reDeterminantreDeterminant = ""
      }
    },
    /**
     * 保存按钮
     * /batchPlanApp/savecheckrecord
     */
    saveSubmit(flag = true) {
      let customNeedDetectMap = {
        // 检验项目
        itemName: h_i18n('222c0f1a6341c9df01ca58fc982db93b'),
        // 技术（标准）要求
        remark: h_i18n('afb44627fabcf435b4633f1f6bd12eb3'),
        rqlProperty: "RQL",
        testAreaMin: "Min",
        testAreaMax: "Max",
        // 单位
        unit: h_i18n('f2996845b6bf0a07fe26f74f35e42ebe')
      }
      let customList = this.dataTableList.filter(v => v.frontKey === "ITEM_NEW")
      //先验证默认
      try {
        customList.forEach(v => {
          for (let o in customNeedDetectMap) {
            if (!v[o]) {
              // 在第；条明细项中，“；”不允许为空
              throw new Error(`${h_i18n('6ab57a09184558bd18fc3368be82e795')}${v.frontIndex}${h_i18n('2b65f4e5a291d73aef8e5f274c05ded2')}${customNeedDetectMap[o]}${h_i18n('f48ab54f727e512ea609812d299c7441')}`)
            }
          }
        })
      } catch (e) {
        // 校验出错
        this.info(e.message ? e.message : h_i18n('031922c203b3bc756072a8df7c950e80'))
        return false
      }

      // 保存中...
      this.startLoading(h_i18n('2a33020e5b56902e4a5609063f5428d7'))


      let obj = {
        patternPlan: {
          ...this.topData,
          fileUuidSize: this.fileUploadToOss.picList.map(v => v.filePath).join(","),
          fileNameSize: this.fileUploadToOss.picList.map(v => v.fileName).join(","),
          fileUuidThirdReport: this.fileUploadToOss.filList.map(v => v.filePath).join(","),
          fileNameThirdReport: this.fileUploadToOss.filList.map(v => v.fileName).join(","),
          testConclusion: this.testConclusion
        },
        patternPlanDetails: this.dataTableList.filter(value => (value.frontKey !== "QB" && value.frontKey !== "QB_NEW")).map(v => {
          let obj
          if (v.dataType === "计量型") {
            obj = {
              ...v,
              factTestValue: v.theNumberDecisionsList.map(val => val.text).join(",")
            }
            delete obj.theNumberDecisionsList
          } else {
            obj = v
          }
          return obj
        }),
        name: this.name,
        nickName: this.testName
      }
      return this.$http({
        method: 'POST',
        url: '/base/patternPlan/saveTestRecordCheckTeam',
        headers: {'content-type': 'application/json'},
        data: obj,
      }).then((res) => {
        this.closeLoading()
        if (res.data.code === "200") {
          if (flag) {
            // 保存成功
            this.success(h_i18n('3b108349b93f7c8c4e2346f8d48c092a'))
            this.getCheckInfoDetail()
          } else {
            return true
          }
        } else {
          this.error(res.data.msg)
          return false
        }
      }).catch((err) => {
        this.closeLoading()
        this.error(err)
        if (flag) {
          return false
        }
      })
    },

    /**
     * 提交按钮
     */
    async onSubmit() {
      if (!this.submitVerify()) return
      if (await this.saveSubmit(false)) {
        // 提交中...
        this.startLoading(h_i18n('abe2c5d2b9a91f822cb1c1ae6aefef08'))
        await this.$http({
          method: 'GET',
          url: '/base/patternPlan/submitTestRecordCheck',
          params: {patternPlanId: this.topData.patternPlanId},
        }).then((res) => {
          this.closeLoading()
          if (res.data.code === "200") {
            // 提交成功
            this.success(h_i18n('23b62e9cbc868e024b80d2e3fad80ac7'))
            this.$router.back()
          } else {
            this.error(res.data.msg)
          }
        }).catch((err) => {
          this.closeLoading()
          this.error(err)
        });
      }
    },

    /**
     * 文件上传
     * @returns {*}
     */
    uploadFile() {
      let uploadFileList = this.fileList.filter(v => v.status === "default")
      if (uploadFileList.length === 0) {
        if (this.fileUploadToOss[this.fileUploadToOss.openPlan + "List"].length !== this.fileList.length) {
          this.fileUploadToOss[this.fileUploadToOss.openPlan + "List"] = this.fileList.map(v => ({fileName: v.name, filePath: v.filePath}))
          this.fileUploadToOss.fileChoose = false
          return false
        }
        // 请选择文件
        this.info(h_i18n('9febf31146d9c96bfde09a4a20dcf17d'))
        return false
      }
      let formData = new FormData()
      uploadFileList.map(v => {
        formData.append('files', v.file)
        v.progress = 50
      })
      return this.$http({
        method: 'post',
        url: '/base/fileUpload/uploadToOss',
        headers: {'Content-Type': 'multipart/form-data'},
        data: formData,
        cache: false,
        processData: false,
        contentType: false,
      }).then((res) => {
        if (res.data.code === "0") {
          let data = res.data.data
          let noList = this.fileList.filter(v => !v.filePath)
          let hasList = this.fileList.filter(v => v.filePath)
          this.fileUploadToOss[this.fileUploadToOss.openPlan + "List"] = [...hasList.map(v => {
            return {
              fileName: v.name,
              filePath: v.filePath
            }

          }), ...data.split(",").map((v, i) => {
            return {
              fileName: noList[i] ? noList[i].name : `computer${this.time()}`,
              filePath: v
            }
          })]
          uploadFileList.map(v => {
            v.progress = 100
            v.status = "success"
          })
          // 上传成功；提示
          this.$confirm(h_i18n('a7699ba73144aad544eb9ac49f82749d'), h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'), {
            // 确定
            confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
            // 取消
            cancelButtonText: h_i18n('625fb26b4b3340f7872b411f401e754c'),
            callback: async action => {
              this.fileUploadToOss.fileChoose = false
            }
          })
        } else {
          return Promise.reject()
        }
      }).catch((err) => {
        uploadFileList.map(v => {
          v.progress = 100
          v.status = "fail"
        })
        // 上传失败
        this.error(h_i18n('54e5de428ca9d59119d4624706215a4d'))
      });
    },
    /**
     * 注册
     */
    init() {
      this.queryToList()
      this.testName = this.$route.query.nickName
      this.name = this.$route.query.name
      this.testTime = this.time(new Date(), 6)
    },
    /**
     * 对标母本 快速检验
     */
    testExpeditedBtn() {
      this.benchmarkingTheMotherPlan.benchmarkingTheMotherFlag = true
      this.postThisPageHeight()
    },
    /**
     * 对标母本 提交
     */
    femaleParentSubmit() {
      if (this.fileUploadToOss.fil2List.length < 1) {
        // 请上传尺寸见证资料
        throw new Error(h_i18n('12607e4b2cc866f7a69e84319b26f31e'))

      }
      this.benchmarkingTheMotherPlan.benchmarkingTheMotherFlag = false
      this.postThisPageHeight()
    },
    /**
     * 对标母本 关闭
     */
    femaleParentClose() {
      this.benchmarkingTheMotherPlan.benchmarkingTheMotherFlag = false
      this.fileUploadToOss.fil2List = []
      this.femaleParent = {}
    }

  },
  created() {
    this.init()

  },
  mounted() {
    // this.getDetailedData();
  },
}
</script>

<style>
.haier-inspection-header .haier-table .haier-table-header .haier-table-header--right {
  width: calc((100% / 6) * 2 - 1px) !important;
}

.h-global-font-blue-disabled {
  color: #b6d5ff;
  cursor: not-allowed;
}

.haier-inspection-footer {
  position: relative;
}
</style>

<style scoped>
/* .config-provide{
  background: #F2F4F7;
} */
.haier-title-lable{
  height: 48px;
  background: #fff !important;
}
.haier-form-area{
  background: #F2F4F7;
}
.haier-form-area .area .h-work-d-body{
  padding: 0;
}
.myTable{
  border-right: 1px solid #e5e6eb !important;
  border-bottom: 1px solid #e5e6eb !important;
}
.h-hwork-inspection-page{
  width: 99%;
  margin: 0 auto;
}
.h-hwork-form-page .haier-title-lable{
  background: #fff;
}
</style>

<style lang="scss">
.line-color1 {
  background-color: #f6edff;
}

.line-color2 {
  background-color: #e1f4ff;
}

.haier-overlay {
  z-index: 1001;
}

.dialog_style {
  z-index: 1000;

  .haier-dialog {
    top: 1%;
  }

  .dialog_table_style {
    .el-table__header-wrapper {
      .el-table__header thead tr th {
        padding: 8px 0 !important;
      }
    }
  }
}

.planHidden {
  display: none;
}

.h-tr-otherstyle {
  td {
    background: #fff !important;
    color: red !important;
  }
}
</style>

<style lang="scss" scoped>
.input_13 {
  flex: none;
  width: 50px !important;
  transition: all 200ms ease-in-out;
}

.check_true {
  width: 200px !important;
  flex: none;
}

.input_borrow {
  display: flex;
  width: 100%;
  align-items: center;

  .input_borrow_input {
    flex: 1;
  }

  .input_borrow_button {
    flex: none;
    width: 50px;
    height: 100%;
    user-select: none;
  }
}

.pointer {
  cursor: pointer;
}
.detail-content{
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin-left: 15px;
  .detail-item{
    width: 25%;
    display: flex;
    .item-label{
      min-width: 45px;
      font-size: 14px;
      color: #4E5969;
    }
    .item-content{
      font-size: 14px;
      color: #1D2129;
    }
  }
}
.myTr :first-child{
  border-top-left-radius: 8px;
  // border-top-right-radius: 8px;
}
.myTr :last-child{
  border-top-right-radius: 8px;
  // border-bottom-right-radius: 8px;
}
.myTr1 :first-child {
  border-bottom-left-radius: 8px;
  // border-top-right-radius: 8px;
}
.myTr1 :last-child{
  border-bottom-right-radius: 8px;
  // border-bottom-right-radius: 8px;
}
</style>